import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalytics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_196_5134)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_196_5134",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_196_5134)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.05005 19.169V17.1248L6.35005 15.8248V19.169H5.05005ZM8.20005 19.169V13.9748L9.35005 12.8248L9.50005 12.9748V19.169H8.20005ZM11.35 19.169V14.3248L12.65 15.6248V19.169H11.35ZM14.5 19.169V14.8748L15.8 13.5748V19.169H14.5ZM17.65 19.169V11.7248L18.95 10.4248V19.169H17.65ZM5.05005 14.1633V12.3248L9.60005 7.77476L13.2 11.3748L18.95 5.62476V7.46326L13.2 13.2133L9.60005 9.61326L5.05005 14.1633Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_196_5134",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgAnalytics;
